import Cookies from 'js-cookie';
import { CONSTANTS } from 'config/constants';

const { TOKEN_KEY, LAB_ID_KEY, COOKIE_OPTIONS, REACT_APP_URI } = CONSTANTS;
const cookieOptions = COOKIE_OPTIONS as Cookies.CookieAttributes;

/**
 * Opens the regular Denthub app in a new tab as the impersonated user.
 *
 * The token comes from super-admin-backend (ES256, one hour). It is written as
 * the regular app's own session cookie, shared on .denthub.com, so the regular
 * app treats the tab like any login; that session has only the user's own
 * rights. This app's session is a separate HttpOnly cookie and is untouched,
 * so there is nothing to "switch back" to: close the tab or log out there.
 */
const DEFAULT_PATH = '/orders/list';

/**
 * `path` is where to land in the regular app, e.g. /order-details/<id>/main-view
 * or /invoices/<id>/summary; it must be an app path, never a full URL.
 */
export const openImpersonationSession = (token: string, wlLabId?: string, path = DEFAULT_PATH): void => {
    Cookies.set(TOKEN_KEY, `JWT ${token}`, cookieOptions);
    if (wlLabId) {
        Cookies.set(LAB_ID_KEY, wlLabId, cookieOptions);
    } else {
        Cookies.remove(LAB_ID_KEY, cookieOptions);
    }
    const appPath = path.startsWith('/') ? path : DEFAULT_PATH;
    window.open(`${REACT_APP_URI}${appPath}`, '_blank', 'noopener');
};
